export default __webpack_public_path__ + "static/media/Blog.89ce0d16.svg";